/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AbertoRouteImport } from './routes/_aberto'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AbertoCatalogoRouteImport } from './routes/_aberto/catalogo'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAssistenteRouteImport } from './routes/_app/assistente'
import { Route as AppPedidosRouteImport } from './routes/_app/pedidos'
import { Route as AppVisitasRouteImport } from './routes/_app/visitas'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AbertoCursosIndexRouteImport } from './routes/_aberto/cursos/index'
import { Route as AbertoEventosIndexRouteImport } from './routes/_aberto/eventos/index'
import { Route as AbertoEventosSlugRouteImport } from './routes/_aberto/eventos/$slug'
import { Route as AppCursosPainelRouteImport } from './routes/_app/cursos/_painel'
import { Route as AppCursosNovoRouteImport } from './routes/_app/cursos/novo'
import { Route as AbertoCursosSlugIndexRouteImport } from './routes/_aberto/cursos/$slug/index'
import { Route as AppCursosPainelFavoritosRouteImport } from './routes/_app/cursos/_painel/favoritos'
import { Route as AppCursosPainelHistoricoRouteImport } from './routes/_app/cursos/_painel/historico'
import { Route as AppCursosPainelSlugAssistirRouteImport } from './routes/_app/cursos/_painel/$slug.assistir'

const AbertoRoute = AbertoRouteImport.update({
  id: '/_aberto',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AbertoCatalogoRoute = AbertoCatalogoRouteImport.update({
  id: '/catalogo',
  path: '/catalogo',
  getParentRoute: () => AbertoRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAssistenteRoute = AppAssistenteRouteImport.update({
  id: '/assistente',
  path: '/assistente',
  getParentRoute: () => AppRoute,
} as any)
const AppPedidosRoute = AppPedidosRouteImport.update({
  id: '/pedidos',
  path: '/pedidos',
  getParentRoute: () => AppRoute,
} as any)
const AppVisitasRoute = AppVisitasRouteImport.update({
  id: '/visitas',
  path: '/visitas',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AbertoCursosIndexRoute = AbertoCursosIndexRouteImport.update({
  id: '/cursos/',
  path: '/cursos/',
  getParentRoute: () => AbertoRoute,
} as any)
const AbertoEventosIndexRoute = AbertoEventosIndexRouteImport.update({
  id: '/eventos/',
  path: '/eventos/',
  getParentRoute: () => AbertoRoute,
} as any)
const AbertoEventosSlugRoute = AbertoEventosSlugRouteImport.update({
  id: '/eventos/$slug',
  path: '/eventos/$slug',
  getParentRoute: () => AbertoRoute,
} as any)
const AppCursosPainelRoute = AppCursosPainelRouteImport.update({
  id: '/cursos/_painel',
  path: '/cursos',
  getParentRoute: () => AppRoute,
} as any)
const AppCursosNovoRoute = AppCursosNovoRouteImport.update({
  id: '/cursos/novo',
  path: '/cursos/novo',
  getParentRoute: () => AppRoute,
} as any)
const AbertoCursosSlugIndexRoute = AbertoCursosSlugIndexRouteImport.update({
  id: '/cursos/$slug/',
  path: '/cursos/$slug/',
  getParentRoute: () => AbertoRoute,
} as any)
const AppCursosPainelFavoritosRoute =
  AppCursosPainelFavoritosRouteImport.update({
    id: '/favoritos',
    path: '/favoritos',
    getParentRoute: () => AppCursosPainelRoute,
  } as any)
const AppCursosPainelHistoricoRoute =
  AppCursosPainelHistoricoRouteImport.update({
    id: '/historico',
    path: '/historico',
    getParentRoute: () => AppCursosPainelRoute,
  } as any)
const AppCursosPainelSlugAssistirRoute =
  AppCursosPainelSlugAssistirRouteImport.update({
    id: '/$slug/assistir',
    path: '/$slug/assistir',
    getParentRoute: () => AppCursosPainelRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/catalogo': typeof AbertoCatalogoRoute
  '/assistente': typeof AppAssistenteRoute
  '/pedidos': typeof AppPedidosRoute
  '/visitas': typeof AppVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/eventos/$slug': typeof AbertoEventosSlugRoute
  '/cursos': typeof AppCursosPainelRouteWithChildren
  '/cursos/novo': typeof AppCursosNovoRoute
  '/cursos/': typeof AbertoCursosIndexRoute
  '/eventos/': typeof AbertoEventosIndexRoute
  '/cursos/favoritos': typeof AppCursosPainelFavoritosRoute
  '/cursos/historico': typeof AppCursosPainelHistoricoRoute
  '/cursos/$slug/': typeof AbertoCursosSlugIndexRoute
  '/cursos/$slug/assistir': typeof AppCursosPainelSlugAssistirRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/catalogo': typeof AbertoCatalogoRoute
  '/assistente': typeof AppAssistenteRoute
  '/pedidos': typeof AppPedidosRoute
  '/visitas': typeof AppVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/eventos/$slug': typeof AbertoEventosSlugRoute
  '/cursos': typeof AbertoCursosIndexRoute
  '/cursos/novo': typeof AppCursosNovoRoute
  '/eventos': typeof AbertoEventosIndexRoute
  '/cursos/favoritos': typeof AppCursosPainelFavoritosRoute
  '/cursos/historico': typeof AppCursosPainelHistoricoRoute
  '/cursos/$slug': typeof AbertoCursosSlugIndexRoute
  '/cursos/$slug/assistir': typeof AppCursosPainelSlugAssistirRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_aberto': typeof AbertoRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_aberto/catalogo': typeof AbertoCatalogoRoute
  '/_app/assistente': typeof AppAssistenteRoute
  '/_app/pedidos': typeof AppPedidosRoute
  '/_app/visitas': typeof AppVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_aberto/eventos/$slug': typeof AbertoEventosSlugRoute
  '/_app/cursos/_painel': typeof AppCursosPainelRouteWithChildren
  '/_app/cursos/novo': typeof AppCursosNovoRoute
  '/_aberto/cursos/': typeof AbertoCursosIndexRoute
  '/_aberto/eventos/': typeof AbertoEventosIndexRoute
  '/_app/cursos/_painel/favoritos': typeof AppCursosPainelFavoritosRoute
  '/_app/cursos/_painel/historico': typeof AppCursosPainelHistoricoRoute
  '/_aberto/cursos/$slug/': typeof AbertoCursosSlugIndexRoute
  '/_app/cursos/_painel/$slug/assistir': typeof AppCursosPainelSlugAssistirRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/catalogo'
    | '/assistente'
    | '/pedidos'
    | '/visitas'
    | '/auth/callback'
    | '/eventos/$slug'
    | '/cursos'
    | '/cursos/novo'
    | '/cursos/'
    | '/eventos/'
    | '/cursos/favoritos'
    | '/cursos/historico'
    | '/cursos/$slug/'
    | '/cursos/$slug/assistir'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/catalogo'
    | '/assistente'
    | '/pedidos'
    | '/visitas'
    | '/auth/callback'
    | '/eventos/$slug'
    | '/cursos'
    | '/cursos/novo'
    | '/eventos'
    | '/cursos/favoritos'
    | '/cursos/historico'
    | '/cursos/$slug'
    | '/cursos/$slug/assistir'
  id:
    | '__root__'
    | '/_aberto'
    | '/_app'
    | '/login'
    | '/_aberto/catalogo'
    | '/_app/assistente'
    | '/_app/pedidos'
    | '/_app/visitas'
    | '/auth/callback'
    | '/_app/'
    | '/_aberto/eventos/$slug'
    | '/_app/cursos/_painel'
    | '/_app/cursos/novo'
    | '/_aberto/cursos/'
    | '/_aberto/eventos/'
    | '/_app/cursos/_painel/favoritos'
    | '/_app/cursos/_painel/historico'
    | '/_aberto/cursos/$slug/'
    | '/_app/cursos/_painel/$slug/assistir'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AbertoRoute: typeof AbertoRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_aberto': {
      id: '/_aberto'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AbertoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_aberto/catalogo': {
      id: '/_aberto/catalogo'
      path: '/catalogo'
      fullPath: '/catalogo'
      preLoaderRoute: typeof AbertoCatalogoRouteImport
      parentRoute: typeof AbertoRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assistente': {
      id: '/_app/assistente'
      path: '/assistente'
      fullPath: '/assistente'
      preLoaderRoute: typeof AppAssistenteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pedidos': {
      id: '/_app/pedidos'
      path: '/pedidos'
      fullPath: '/pedidos'
      preLoaderRoute: typeof AppPedidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/visitas': {
      id: '/_app/visitas'
      path: '/visitas'
      fullPath: '/visitas'
      preLoaderRoute: typeof AppVisitasRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_aberto/cursos/': {
      id: '/_aberto/cursos/'
      path: '/cursos'
      fullPath: '/cursos/'
      preLoaderRoute: typeof AbertoCursosIndexRouteImport
      parentRoute: typeof AbertoRoute
    }
    '/_aberto/eventos/': {
      id: '/_aberto/eventos/'
      path: '/eventos'
      fullPath: '/eventos/'
      preLoaderRoute: typeof AbertoEventosIndexRouteImport
      parentRoute: typeof AbertoRoute
    }
    '/_aberto/eventos/$slug': {
      id: '/_aberto/eventos/$slug'
      path: '/eventos/$slug'
      fullPath: '/eventos/$slug'
      preLoaderRoute: typeof AbertoEventosSlugRouteImport
      parentRoute: typeof AbertoRoute
    }
    '/_app/cursos/_painel': {
      id: '/_app/cursos/_painel'
      path: '/cursos'
      fullPath: '/cursos'
      preLoaderRoute: typeof AppCursosPainelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cursos/novo': {
      id: '/_app/cursos/novo'
      path: '/cursos/novo'
      fullPath: '/cursos/novo'
      preLoaderRoute: typeof AppCursosNovoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_aberto/cursos/$slug/': {
      id: '/_aberto/cursos/$slug/'
      path: '/cursos/$slug'
      fullPath: '/cursos/$slug/'
      preLoaderRoute: typeof AbertoCursosSlugIndexRouteImport
      parentRoute: typeof AbertoRoute
    }
    '/_app/cursos/_painel/favoritos': {
      id: '/_app/cursos/_painel/favoritos'
      path: '/favoritos'
      fullPath: '/cursos/favoritos'
      preLoaderRoute: typeof AppCursosPainelFavoritosRouteImport
      parentRoute: typeof AppCursosPainelRoute
    }
    '/_app/cursos/_painel/historico': {
      id: '/_app/cursos/_painel/historico'
      path: '/historico'
      fullPath: '/cursos/historico'
      preLoaderRoute: typeof AppCursosPainelHistoricoRouteImport
      parentRoute: typeof AppCursosPainelRoute
    }
    '/_app/cursos/_painel/$slug/assistir': {
      id: '/_app/cursos/_painel/$slug/assistir'
      path: '/$slug/assistir'
      fullPath: '/cursos/$slug/assistir'
      preLoaderRoute: typeof AppCursosPainelSlugAssistirRouteImport
      parentRoute: typeof AppCursosPainelRoute
    }
  }
}

interface AbertoRouteChildren {
  AbertoCatalogoRoute: typeof AbertoCatalogoRoute
  AbertoEventosSlugRoute: typeof AbertoEventosSlugRoute
  AbertoCursosIndexRoute: typeof AbertoCursosIndexRoute
  AbertoEventosIndexRoute: typeof AbertoEventosIndexRoute
  AbertoCursosSlugIndexRoute: typeof AbertoCursosSlugIndexRoute
}

const AbertoRouteChildren: AbertoRouteChildren = {
  AbertoCatalogoRoute: AbertoCatalogoRoute,
  AbertoEventosSlugRoute: AbertoEventosSlugRoute,
  AbertoCursosIndexRoute: AbertoCursosIndexRoute,
  AbertoEventosIndexRoute: AbertoEventosIndexRoute,
  AbertoCursosSlugIndexRoute: AbertoCursosSlugIndexRoute,
}

const AbertoRouteWithChildren =
  AbertoRoute._addFileChildren(AbertoRouteChildren)

interface AppCursosPainelRouteChildren {
  AppCursosPainelFavoritosRoute: typeof AppCursosPainelFavoritosRoute
  AppCursosPainelHistoricoRoute: typeof AppCursosPainelHistoricoRoute
  AppCursosPainelSlugAssistirRoute: typeof AppCursosPainelSlugAssistirRoute
}

const AppCursosPainelRouteChildren: AppCursosPainelRouteChildren = {
  AppCursosPainelFavoritosRoute: AppCursosPainelFavoritosRoute,
  AppCursosPainelHistoricoRoute: AppCursosPainelHistoricoRoute,
  AppCursosPainelSlugAssistirRoute: AppCursosPainelSlugAssistirRoute,
}

const AppCursosPainelRouteWithChildren = AppCursosPainelRoute._addFileChildren(
  AppCursosPainelRouteChildren,
)

interface AppRouteChildren {
  AppAssistenteRoute: typeof AppAssistenteRoute
  AppPedidosRoute: typeof AppPedidosRoute
  AppVisitasRoute: typeof AppVisitasRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCursosPainelRoute: typeof AppCursosPainelRouteWithChildren
  AppCursosNovoRoute: typeof AppCursosNovoRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAssistenteRoute: AppAssistenteRoute,
  AppPedidosRoute: AppPedidosRoute,
  AppVisitasRoute: AppVisitasRoute,
  AppIndexRoute: AppIndexRoute,
  AppCursosPainelRoute: AppCursosPainelRouteWithChildren,
  AppCursosNovoRoute: AppCursosNovoRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AbertoRoute: AbertoRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
